import React from "react";
import { toast as baseToast } from "react-toastify";
import { SystemNotification } from "@blueprint/ui";


export const toast = (message: string): void => {
    baseToast.info(
            <SystemNotification
                title="Notification."
                variant="info"
                closeButton={<></>}
            >
                {message}
        </SystemNotification>,
        {
            autoClose: 3000,
            icon: false,
        },
    );
};

export const toastError = (
    message: string,
    isShowTitle: boolean = true,
): void => {
    baseToast.error(
            <SystemNotification
            title={isShowTitle ? "Global error." : ""}
                variant="error"
                closeButton={<></>}
            >
                {message}
        </SystemNotification>,
        {
        autoClose: 3000,
        icon: false,
        },
    );
};
